<template>
    <section class="footer">
        <div class="container">
            <div class="columns">
                <div class="column">
                    <div class="footer__wrapper columns is-multiline">
                        <div class="footer__logo column is-one-quarter-desktop is-full">
                            <router-link :to="{path: '/'}">
                                <LogoBottom></LogoBottom>
                            </router-link>    
                            <div class="footer__socials">
                                <a href="https://www.instagram.com/tvp_abc/?__coig_restricted=1" target="_blank" class="footer__socials-icon" aria-label="instagram">
                                    <IconInstagram></IconInstagram>
                                </a>
                                <a href="https://www.youtube.com/c/tvpabc" target="_blank" class="footer__socials-icon" aria-label="youtube">
                                    <IconYoutube></IconYoutube>
                                </a>
                                <a href="https://www.facebook.com/tvpabc" target="_blank" class="footer__socials-icon" aria-label="facebook">
                                    <IconFacebook></IconFacebook>
                                </a>
                            </div>
                        </div>

                        <div class="footer__links is-three-quarters-desktop column is-full">
                            <ModuleFooterLinks></ModuleFooterLinks>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <ModuleFooterLogos></ModuleFooterLogos>

    <div class="footer__bottom"><p class="footer__bottom-name">Telewizja Polska Spółka Akcyjna w likwidacji</p></div>
</template>

<script>
import IconInstagram from "./elements/icons/IconInstagram.vue";
import IconYoutube from "./elements/icons/IconYoutube.vue";
import IconFacebook from "./elements/icons/IconFacebook.vue";
import LogoBottom from "./elements/LogoBottom.vue";
import ModuleFooterLinks from "./modules/ModuleFooterLinks.vue";
import ModuleFooterLogos from "./modules/ModuleFooterLogos.vue";

export default {
    name: "Footer",
    components: {
        IconInstagram,
        IconYoutube,
        IconFacebook,
        LogoBottom,
        ModuleFooterLinks,
        ModuleFooterLogos
    },  
}
</script>